import './ProjectStatusBadge.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { ProjectStatus } from '../../../../__legacy__/modules/projects/projects.model';
import { StatusBadge } from '../../../../design/statusBadge/StatusBadge';

interface IProjectStatusProps {
  projectStatus: ProjectStatus;
}

export const ProjectStatusBadge = ({ projectStatus }: IProjectStatusProps): ReactElement => {
  const { t } = useTranslator();
  const getText = (): string => {
    switch (projectStatus) {
      case ProjectStatus.Draft:
        return t('project_status_draft');
      case ProjectStatus.Published:
        return t('project_status_published');
    }
    return '';
  };

  return (
    <StatusBadge
      className={classNames('project-status-badge', projectStatus.toLowerCase())}
      text={getText()}
    />
  );
};
